module.exports = __webpack_public_path__ + "static/media/lily.c418c328.png";